export default __webpack_public_path__ + "static/media/blanket.02549b59.jpg";